import React from 'react';
import Img from "gatsby-image"
// import classNames from 'classnames'

function Gallary({ data,  }) {
  return (
    <div className="column recipe-card is-one-fourth">
        <div className="card companies">
          <div className="card-image">
            <Img fluid={data.fluid} imgStyle={{
              objectFit: "cover",
            }} />
          </div>

        </div>
    </div>
  );
}

export default Gallary; 